import { useTranslation } from 'react-i18next';
import { FiArrowLeft, FiMenu } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../Logo';
import SideMenu from './SideMenu';
import { useState } from 'react';
import ThemeToggle from '../ThemeToggle';
import LanguageSelector from '../LanguageSelector';

interface TopBarProps {
  showBack?: boolean;
  title?: string;
}

export default function TopBar({ showBack, title }: TopBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  const isRootPath = location.pathname === '/';

  const handleBack = () => {
    navigate('/');
  };

  const getTitle = () => {
    if (title) return title;
    if (location.pathname.startsWith('/students/')) return t('student');
    const path = location.pathname.substring(1);
    return t(path);
  };

  return (
    <>
      <div className="sticky top-0 z-40 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex h-14 items-center justify-between">
            <div className="flex items-center gap-2">
              {isRootPath && (
                <button
                  type="button"
                  className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
                  onClick={() => setIsSideMenuOpen(true)}
                >
                  <FiMenu className="h-5 w-5" />
                </button>
              )}
              {showBack && !isRootPath && (
                <button
                  onClick={handleBack}
                  className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
                >
                  <FiArrowLeft className="h-5 w-5" />
                </button>
              )}
              {isRootPath ? (
                <Logo className="h-7 w-auto" />
              ) : (
                <button
                  onClick={handleBack}
                  className="text-base font-semibold text-gray-900 dark:text-white hover:text-gray-700 dark:hover:text-gray-300"
                >
                  {getTitle()}
                </button>
              )}
            </div>
            
            <div className="flex items-center gap-2">
              <ThemeToggle />
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>

      <SideMenu 
        isOpen={isSideMenuOpen} 
        onClose={() => setIsSideMenuOpen(false)} 
      />
    </>
  );
}